module.exports = "<p>\r\n  informes-mensuales works!\r\n</p>\r\n"